import React from "react";
import { IntlProvider } from "react-intl";
import conversationsLocales from "../locales/conversations.json";
import IgChat from "./conversations_components/IgChat";
import RootStore from "./conversations_components/stores/Root";
import LocaleStore from "./common_components/localization/LocaleStore";
import { Provider } from "mobx-react";
import { camelCase } from "@ridi/object-case-converter";


export default class IgChatContainer extends React.Component {
  constructor(props) {
    super(props);
    const myProps = camelCase(props, true);
    const localeStore = new LocaleStore(myProps.userLocale, [conversationsLocales]);
    this.rootStore = new RootStore(myProps.currentUser, localeStore, myProps);
  }

  componentDidMount() {
    this.rootStore.contactsStore.online(true);
  }

  componentWillUnmount() {
    this.rootStore.contactsStore.online(false);
  }

  render() {
    return (

      <Provider
        rootStore={this.rootStore}
        uiStore={this.rootStore.uiStore}
        conversationsStore={this.rootStore.conversationsStore}
        contactsStore={this.rootStore.contactsStore}
      >
        <IntlProvider
          locale={this.rootStore.localeStore.locale}
          messages={this.rootStore.localeStore.messages}
        >
          <IgChat />
        </IntlProvider>
      </Provider>
    );
  }
}
